import AbsComponent from "../../common/AbsComponent";

/**
* subBanner class
* @category main
*/
class SubBanner extends AbsComponent{
    constructor(_store={}, _el=''){
        super(_store, _el);

        // 렌더 하고 - 클라이언트 렌더링
        this.store.getData('subBanner', {}, this.render.bind(this));
    }

    render(_jsonData = {}) {
        // console.log('render SubBanner ----->', _jsonData);
        $(this.el).append(this.template( _jsonData ));
    }

    template(_jsonData={}){
        let templ = ''; //템플릿

        _jsonData = JSON.parse(_jsonData.jsonData); 

        templ = `
            <section class="sub-banner">
                <a class="sub-banner-link" href="${_jsonData['link']}">
                    <img class="sub-banner-img only-mo" src="${_jsonData['img-m']}" alt="">
                    <img class="sub-banner-img only-tablet" src="${_jsonData['img-pc']}" alt="">
                    <p class="sub-banner-title">${_jsonData['title']}</p>
                    <p class="sub-banner-desc">${_jsonData['desc']}</p>
                </a>
            </section>
        `;
        return templ;
    }

} // end of class

export default SubBanner;